// "SKU: …" en gris debajo del nombre de un producto, en todas las pantallas que lo muestran
// (ADR-2026-10-22-el-sku-se-ve-debajo-del-nombre). Sin SKU no dibuja nada: la tarjeta queda como
// siempre. Hereda la alineación del nombre; el tamaño va relativo al de la tarjeta (`chico` para
// las grillas densas y los chips).
import React from "react";

export const SkuDelProducto: React.FC<{
  sku?: string | null;
  chico?: boolean;
  /** Sobre la foto (el nombre va en blanco sobre un degradé): gris claro en vez de oscuro. */
  sobreFoto?: boolean;
  className?: string;
}> = ({ sku, chico = false, sobreFoto = false, className = "" }) => {
  const valor = sku?.trim();
  if (!valor) return null;
  return (
    <span
      title={`SKU: ${valor}`}
      className={`block truncate font-normal leading-tight ${sobreFoto ? "text-white/70" : "text-black/40"} ${chico ? "text-[10.5px]" : "text-[11.5px]"} ${className}`}
    >
      SKU: {valor}
    </span>
  );
};
